'use es6';

export default (({
  apiClient
}) => {
  return apiClient.get(`users-query/v1/app/user`);
});